import { createContext, type ReactNode } from "react";

/**
 * 各 page が DesktopLayout に流し込む chrome (header toolbar / page label) の slot。
 *
 * mobile では `MobileLayout` がこの Provider を mount しないため、
 * `useContext(ChromeContext)` は defaultValue (noop) を返す。
 * → page 側は device 判定なしで `useDesktopChrome` を呼んで OK。
 */
export interface DesktopChrome {
  /** Header toolbar slot (page-context-specific button 群) */
  toolbar?: ReactNode;
  /** Page label band 文字列（"カタログ"、"スレッド" 等） */
  pageLabel?: string;
  /** History Sidebar を表示するか (page が opt-in する) */
  showHistorySidebar?: boolean;
}

interface DesktopChromeContextValue {
  chrome: DesktopChrome;
  setChrome: (chrome: DesktopChrome) => void;
}

const noop: (chrome: DesktopChrome) => void = () => undefined;

export const ChromeContext: React.Context<DesktopChromeContextValue> =
  createContext<DesktopChromeContextValue>({
    chrome: {},
    setChrome: noop,
  });
